import React from 'react'
import * as PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../Icon'
import styles from './icon-button.module.scss'

const IconButton = ({
  name,
  size = 'm',
  className,
  color,
  colorHover = null,
  colorActive = null,
  borderColor = null,
  bgColor = null,
  bgColorHover = null,
  bgColorActive = null,
  width,
  rounded = true,
  component = null,
  active = false,
  additionalIcon = null,
  noHover = false,
  children = null,
  style = {},
  variant = 'default',
  disabled = false,
  title = '',
  ...rest
}) => {
  const iconProps = {
    name,
    size: size === 'xs' ? 's' : size,
    color,
    width,
    rounded,
    active,
  }

  return React.createElement(
    component || 'button',
    {
      title,
      disabled,
      type: 'button',
      ...rest,
      style: {
        ...style,
        '--color': color && `var(--color-${color})`,
        '--color-hover': colorHover && `var(--color-${colorHover})`,
        '--color-active': colorActive && `var(--color-${colorActive})`,
        '--bg-color': bgColor && `var(--color-${bgColor})`,
        '--bg-color-hover': bgColorHover && `var(--color-${bgColorHover})`,
        '--bg-color-active': bgColorActive && `var(--color-${bgColorActive})`,
      },
      className: clsx(
        'icon-button',
        className,
        styles.button,
        styles[`button_variant-${variant}`],
        {
          [styles[`button_size-${size}`]]: !width,
          [styles['button_rounded']]: rounded,
          [styles['button_active']]: active,
          [styles['button_has-hover']]: !noHover,
          [styles['button_not-hover']]: noHover,
          [styles['button_disabled']]: disabled,
        },
      ),
    },
    <>
      <div className={styles.button__icon}>
        <Icon {...iconProps} inheritColor={!!color} />
        {additionalIcon &&
          React.cloneElement(additionalIcon, {
            className: clsx(
              additionalIcon.className,
              styles['button__additional-icon'],
            ),
          })}
      </div>
      {children && <div className={styles.button__label}>{children}</div>}
    </>,
  )
}

IconButton.propTypes = {
  width: PropTypes.number,
  name: PropTypes.string,
  size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']),
  rounded: PropTypes.bool,
  active: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.string,
  colorHover: PropTypes.string,
  colorActive: PropTypes.string,
  bgColor: PropTypes.string,
  bgColorHover: PropTypes.string,
  bgColorActive: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  additionalIcon: PropTypes.object,
  noHover: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  variant: PropTypes.oneOf(['default', 'contained']),
  disabled: PropTypes.bool,
  title: PropTypes.string,
}

export default IconButton
